export default __webpack_public_path__ + "static/cup_icon-0fe3b17be4d1d46df9f32f9a704448f2.png";